import vietnam from "../../assets/images/flag/VN.png"
import usa from "../../assets/images/flag/US.png"
import { PhoneRegex } from '../../utils/regex/Regex'

const CountriesData = () => {
    return (
        [
            {
                alpha3Code : "VNM",
                countryName: "Việt Nam",
                placeHolder: "093 777 4567",
                phoneCode: "+84",
                phoneRegex : PhoneRegex.vietnam,
                flag: vietnam
            },
            {
                alpha3Code: "USA",
                countryName: "United States",
                placeHolder: "(201) 555-4567",
                phoneCode: "+1",
                phoneRegex : PhoneRegex.usa,
                flag: usa
            },
        ]
    )
}

export default CountriesData